import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAcneBodyWashGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M30 10.224C29.902 8.677 26.878 8 24.049 8c-2.83 0-5.951.677-6.049 2.224v27.36c0 1.546 3.122 2.32 6.049 2.32 2.927 0 6.049-.677 6.049-2.32v-20.4L30 10.224c0 .096 0 0 0 0Zm-10.732 0c.293-.29 1.854-1.064 4.78-1.064 2.83 0 4.391.677 4.781 1.064l.098.096c0 .097-.39.29-.878.484-.878.29-2.244.58-4 .58-1.854 0-3.122-.29-3.903-.58-.585-.194-.878-.387-.878-.58 0 .096 0 0 0 0Zm9.561 6.96c-.097.29-1.658 1.064-4.78 1.064-3.122 0-4.683-.774-4.78-1.064V11.77c1.17.58 3.024.87 4.78.87 1.756 0 3.61-.29 4.78-.87v5.414Zm-4.78 21.56c-3.122 0-4.683-.774-4.78-1.064V18.73c1.17.58 3.024.87 4.78.87 1.756 0 3.61-.29 4.78-.87V37.68c-.097.29-1.658 1.063-4.78 1.063Z",
    fill: "currentColor"
  }));
}

export { SvgAcneBodyWashGlyph as default };
